import React from 'react'
import { Grid } from '@material-ui/core'
import clsx from 'clsx'

export default (props) => {
  const { children, gridItemClassName, ...containerProps } = props
  const allChildrend = React.Children.map(children, (element, index) => {
    if (!React.isValidElement(element)) return
    const { ignoregrid } = element.props
    if (ignoregrid) return <div className="w-full">{element}</div>
    else
      return (
        <Grid item key={index} className="w-full">
          <div className={clsx('w-full', gridItemClassName)}>{element}</div>
        </Grid>
      )
  })
  return (
    <Grid container {...containerProps}>
      {allChildrend}
    </Grid>
  )
}
